import React from 'react'
import Collaborate from './Homepage-components/Collaborate'
import Assetgraphanddata from './Homepage-components/Assetgraphanddata'
import MissionandVision from './Homepage-components/MissionandVision'
import Firstpage from './Homepage-components/Firstpage'
import Investments from './Homepage-components/Investments'

export default function Homepage() {
  return (
    <>
    {/* All sub section of the Homepage */}
    <Firstpage/>
    <Investments/>
    <MissionandVision/>
    <Assetgraphanddata/>
    <Collaborate/>
    </>
  )
}
